import { styled } from '@mui/material/styles';

const Asterisk = styled('span')(({ theme }) => ({
  color: theme.vars.tokens?.bigid?.negativeStrong,
  marginLeft: '4px',
}));

const Label = styled('label')(`
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`);

const FieldWrapper = styled('div')<{ isFlex: boolean }>(({ isFlex }) => ({
  // a11y
  'label.MuiFormLabel-root': {
    display: 'none',
  },
  ...(isFlex ? { display: 'flex', alignItems: 'center', gap: 8 } : {}),
}));

export const StyledFieldWrapper = {
  Asterisk,
  Label,
  FieldWrapper,
};
